<script setup>
import { Handle, Position } from '@vue-flow/core'
import { computed } from 'vue'

const props = defineProps({
    id: String,
    data: Object,
})

const paths = computed(() => props.data?.config?.paths || [{ id: 'a', label: 'A', percentage: 50 }, { id: 'b', label: 'B', percentage: 50 }])
</script>

<template>
    <div class="workflow-node workflow-node--split">
        <Handle type="target" :position="Position.Top" />
        <div class="workflow-node__type">A/B SPLIT</div>
        <div class="workflow-node__title">
            {{ paths.map(p => `${p.label} ${p.percentage}%`).join(' / ') }}
        </div>
        <Handle
            v-for="(path, index) in paths"
            :key="path.id"
            type="source"
            :position="Position.Bottom"
            :id="path.id"
            :style="{ left: `${(100 / (paths.length)) * (index + 0.5)}%` }"
        />
    </div>
</template>
